import { EMPTY_LIST } from '../../constants/common'
import {
  getMassActionExcludeIdParam,
  getMassActionSelectedItems,
} from '../../utils/common'
import { getIdFilterParam } from '../../utils/filter'
import { isSubRead, isSubUnread } from '../../utils/route'

import { REQUEST_MASS_ACTION_ID_KEY } from './Request.constants.actions'

export function getRequestMassActionUnreadFilter(sub) {
  return isSubUnread(sub) ? true : isSubRead(sub) ? false : undefined
}

export function getRequestMassActionFilters({
  excludeIds,
  filterValues,
  ids,
  selectAllPages,
  sub,
}) {
  return {
    ...filterValues,
    [REQUEST_MASS_ACTION_ID_KEY]: getIdFilterParam({
      filterValues,
      ids,
      selectAllPages,
    }), // needs to prevent action with related request
    exclude_id: getMassActionExcludeIdParam({ excludeIds, selectAllPages }),
    unread: getRequestMassActionUnreadFilter(sub),
  }
}

export function getRequestMassActionDayLoadProps({
  excludeIds,
  filterValues,
  pageItems,
  selectAllPages,
  selected,
  selectedIds,
  sub,
}) {
  return {
    ...(selectAllPages
      ? {
          all: selectAllPages,
          filters: getRequestMassActionFilters({
            excludeIds,
            filterValues,
            selectAllPages,
            sub,
          }),
          requestIds: EMPTY_LIST,
        }
      : { requestIds: selectedIds }),
    requests: getMassActionSelectedItems({
      excludeIds,
      pageItems,
      selectAllPages,
      selected,
    }),
  }
}
